import i18n from 'i18n-js';
import memoize from 'lodash.memoize';
import {
  languageCodes,
} from '../constants/languages';

export const tranlsationGetters = {
  en: {
    hello: 'Hello Dude',
    // start general
    addButton: 'Add',
    editButton: 'Edit',
    updatedMessage: 'Updated Successfully',
    delete: 'Delete',
    deleteAlert: "Are you sure you want to delete ?",
    deletedMessage: 'Deleted Successfully',
    errorMessage: 'Something Went Wrong',
    copyMessage: 'Copied Successfully',
    title: 'Title',
    name: 'name',
    action: 'Action',
    emptyTable: 'there is no data',
    description: 'Description',
    FormActiveLabel: 'Active',
    FormNotActiveLabel: 'Not Active',
    Status: 'Status',
    wdcBranchRequiredErrorMessage: 'WDC Branch Required',
    createdMessage: 'Created Successfully',
    about: 'About',
    easyfinance: 'EZ Finance',
    partnersAbout: 'Partners About',
    offersAbout: 'Offers About',
    savedMessage: 'Saved Successfully',
    unknownStatus: 'Status unknown',
    missingFields: 'Missing Fields',
    // end general
    loginScreen: {
      screenTitle: 'Login',
      email: 'Email',
      emailNotValid: 'Please enter a valid email',
      password: 'Password',
      loginError: 'Invalid email or password',
      loginButton: 'Login',
      forgotPasswordButton: 'Forgot Password ?',
      forgotPasswordEnterEmailMessage: 'Enter Your Email Address',
      emailSentSuccessMessage: 'An Email has been Sent Containing the Link to Reset your Password\n'
          + 'Please Access your Email to Continue with the Reset Process',
      passwordValidationMessage: 'Password has to be at least 8 characters!',
      requestConfirmation: 'Password confirmation is required!',
      resetPasswordSuccess: 'You have Successfully changed your password you can now Login using your new password',
    },
    // start Branches tab
    branchesTab: 'Branches Management',
    editBranchPageTitle: 'Edit Branch',
    addBranchPageTitle: 'New Branch',
    addBranchPageFormTitle: 'Branch Info',
    addBranchPageFormEnglishName: 'Branch English Name',
    addBranchPageFormArabicName: 'Branch Arabic Name',
    addBranchPageFormWaterfrontType: 'Waterfront',
    addBranchPageFormClubType: 'Club',
    addBranchPageFormArabicDescription: 'Branch Arabic Description',
    addBranchPageFormEnglishDescription: 'Branch English Description',
    addBranchPageFormBranchLocation: 'Branch Location',
    addBranchPageFormWdcBranch: 'Select WDC Branch',
    addBranchPageFormBackgroundImage: 'Background Image',
    addBranchPageFormGalleryImages: 'Gallery Images',
    addBranchPageFormGalleryVideos: 'Gallery Videos',
    addBranchPageFormGalleryImages360: 'Gallery 360 Images',
    addBranchPageFormMasterPlanImage: 'Master Plan Image',
    addBranchPageFormMasterPlanWarningMessage: 'Aspect Ratio should be 16:9',
    addBranchPageFormFeatures: 'Features',
    addVideoTextMessage: 'Try dropping some files here, or click to select files to upload.',
    addImageErrorMessage: 'Image size exceeds the limit',
    addImageSuccessMessage: 'Image was uploaded successfully',
    // use String.prototype.replace('_SIZE_', "SIZE IN KB") with the following two strings:
    addBranchPageFormDropzoneTextMessage: 'Try dropping some files here, or click to select files to upload. (Max _SIZE_ KB)',
    addBranchPageFormMasterPlanTextMessage: 'Try dropping some files here, or click to select files to upload. (Max _SIZE_ KB)',
    // branch features
    branchFeatureTableTitle: 'Branch Features',
    branchFeatureEmptyTableMessage: 'No features found',
    // End Branches tab
    academiesTab: 'Management',
    // start add/edit article
    editAcademyPageTitle: 'Edit Academy',
    addAcademyPageTitle: 'New Academy',
    addAcademyPageFormTitle: 'Academy Info',
    addAcademyPageFormEnglishName: 'Name',
    addAcademyPageFormArabicName: 'Arabic Name',
    addAcademyPageFormEnglishDescription: 'Description',
    addAcademyPageFormArabicDescription: 'Arabic Description',
    addAcademyPageFormAvailableBranches: 'Academy Available Branches',
    addAcademyPageFormGallery: 'Gallery',
    addAcademyPageFormPreviewImage: 'Preview Card Thumbnail',
    addAcademyPageFormBackgroundImage: 'Details Page Background Thumbnail',
    addAcademyPageFormStatus: 'Status',
    addAcademyPageFormStatusActiveLabel: 'Active',
    addAcademyPageFormStatusInactiveLabel: 'Not active',
    addAcademyPageFormAcademyCategories: 'Academy News Categories',
    addAcademyPageFormSports: 'Available Sports',
    wdcAcademyRequiredErrorMessage: 'WDC Academy is required!',
    // end add/edit article
    // start news tab
    newsTab: 'News Management',
    newsListPageTitle: 'News Management',
    newsListArticleColumnTitle: 'Article',
    newsListStatusColumnTitle: 'Status',
    newsListCategoryColumnTitle: 'Category',
    newsListLiveColumnTitle: 'Live Status',
    newsListStartDateColumnTitle: 'Start Date',
    newsListEndDateColumnTitle: 'End Date',
    newsListStatusActive: 'Active',
    newsListStatusInactive: 'Not Active',
    newsListEditColumnTitle: 'Edit',
    newsListEditButton: 'Edit',
    newsListNoArticlesMessage: 'There are no articles yet. Please add one now',
    newsListClearFiltersButton: 'Clear Filters',
    newsListDynamicLink: 'Deep Link',
    newCopyDynamicLink: 'Copy',
    newGenerateDynamicLink: 'Generate',
    featuredNewsListDeactivationWarning:
        'This Article is a Featured Article are you sure you want to Deactivate It Deactivating is a Permenant Action and Can not be undone ?',
    homeTileNewsListDeactivationWarning:
        'This Article is a Home Tile Article are you sure you want to Deactivate It Deactivating is a Permenant Action and Can not be undone ?',
    homeTileAndFeaturedNewsListDeactivationWarning:
        'This Article is a Featured and Home Tile Article are you sure you want to Deactivate It Deactivating is a Permenant Action and Can not be undone ?',
    // start add/edit article
    editArticlePageTitle: 'Edit Article',
    addArticlePageTitle: 'New Article',
    addArticlePageFormTitle: 'Article Info',
    addArticlePageFormArticleTitle: 'Title',
    addArticlePageFormArticleArabicTitle: 'Arabic Title',
    addArticlePageFormPreview: 'Preview',
    addArticlePageFormArabicPreview: 'Arabic Preview',
    addArticlePageFormDescription: 'Description',
    addArticlePageFormArabicDescription: 'Arabic Description',
    addArticlePageFormCategory: 'Category',
    addArticlePageFormImage: 'Image',
    addArticlePageFormVideo: 'Video',
    addArticlePageFormWarningImageMessage: 'Warning: Article will be published with WDC Logo',
    addArticlePageFormAutoScheduled: 'AutoScheduled',
    addArticlePageFormAutoScheduledOffLabel: 'AutoScheduled On',
    addArticlePageFormAutoScheduledOnLabel: 'AutoScheduled Off',
    addArticlePageFormStatus: 'Status',
    addArticlePageFormStatusPublishedLabel: 'Active',
    addArticlePageFormStatusUnpublishedLabel: 'not Active',
    addArticlePageFormStartDate: 'Start Date',
    addArticlePageFormEndDate: 'End Date',
    // end add/edit article
    // end news tab
    // Start Academies Announcements tab
    academiesAnnouncementsTab: 'Announcements',
    announcementListPageTitle: 'Academies Announcements',
    addAnnouncementPageFormTitle: 'Announcement Info',
    announcementListNoArticlesMessage: 'There are no Articles yet. Please add one now',
    academiesAnnouncementsTabEditAnnouncement: 'Edit Announcement',
    academiesAnnouncementsTabAddAnnouncement: 'Add Announcement',
    academiesAnnouncementsListNoCategoriesMessage: 'There are no Articles yet. Please add one now',
    academiesAnnouncementsFormArticleNameEn: 'ARTICLE NAME',
    editAcademiesAnnouncementsArticleLayoutImages: 'ARTICLE LAYOUT IMAGES',
    academiesAnnouncementsFormArticleNameAr: 'ARTICLE NAME',
    editAcademiesAnnouncementsArticlePreview: 'ARTICLE PREVIEW',
    // end Academies Announcements tab
    // start news Categories tab
    newsCategoriesTab: 'News Categories Management',
    newsCategoriesListPageTitle: 'News Categories Management',
    newsCategoriesListCategoryColumnTitle: 'Category',
    newsCategoriesListEditColumnTitle: 'Edit',
    newsCategoriesListEditButton: 'Edit',
    newsCategoriesListAddButton: 'Add',
    newsCategoriesListNoCategoriesMessage: 'There are no Categories yet. Please add one now',
    editNewsCategoryPageTitle: 'Edit Category',
    addNewsCategoryPageTitle: 'New Category',
    newsCategoryFormTitle: 'Category Info',
    editNewsCategoryTitleEn: 'Category Title',

    editNewsCategoryTitleArabic: 'Category Arabic Title',
    editNewsCategoryTitleAr: 'Category Title',
    // end News Categories tab
    // start restaurants tab
    restaurantsTab: 'Restaurants Management',
    restaurantsListPageTitle: 'Restaurants Management',
    restaurantsListRestaurantColumnTitle: 'Restaurant',
    restaurantsListStatusColumnTitle: 'Status',
    restaurantsListStatusActive: 'Active',
    restaurantsListStatusInactive: 'Not active',
    restaurantsListEditColumnTitle: 'Edit',
    restaurantsListEditButton: 'Edit',
    notificationsIsBatchesColumnTitle: 'Is Batches?',
    restaurantsListEditColumnMenu: 'Menu',
    restaurantsListMenuButton: 'Menu',
    restaurantsListNoRestaurantsMessage: 'There are no restaurants yet. Please add one now',
    // start add/edit restaurant
    editRestaurantPageTitle: 'Edit Restaurant',
    addRestaurantPageTitle: 'New Restaurant',
    addRestaurantPageFormTitle: 'Restaurant Info',
    addRestaurantPageFormEnglishTitle: 'Title',
    addRestaurantPageFormArabicTitle: 'Arabic Title',
    addRestaurantPageFormEnglishDescription: 'Description',
    addRestaurantPageFormArabicDescription: 'Arabic Description',
    addRestaurantPageFormAvailableBranches: 'Available Branches',
    addRestaurantPageFormLogo: 'Logo',
    addRestaurantPageFormImages: 'Gallery',
    // end add/edit restaurant
    // start restaurant category
    restaurantCategoriesListPageTitle: 'Categories Management',
    restaurantCategoriesListCategoryColumnTitle: 'Category',
    restaurantCategoriesListStatusColumnTitle: 'Status',
    restaurantCategoriesListStatusActive: 'Active',
    restaurantCategoriesListStatusInactive: 'Not active',
    restaurantCategoriesListEditColumnTitle: 'Edit',
    restaurantCategoriesListEditButton: 'Edit',
    restaurantCategoriesListItemsColumnTitle: 'Items',
    restaurantCategoriesListItemsButton: 'Items',
    restaurantCategoriesListNoCategoriesMessage: 'There are no categories yet. Please add one now',
    // start restaurant category
    menuListPageTitle: 'Menu Management',
    menuListCategoryColumnTitle: 'Menu',
    menuListStatusColumnTitle: 'Status',
    menuListPriceColumnTitle: 'Price',
    menuListStatusActive: 'Active',
    menuListStatusInactive: 'Not active',
    menuListEditColumnTitle: 'Edit',
    menuListEditButton: 'Edit',
    menuListItemsColumnTitle: 'Items',
    menuListItemsButton: 'Items',
    menuListNoCategoriesMessage: 'There are no menu yet. Please add one now',
    // start restaurant add/edit category
    addMenuPageFormTitle: 'Menu Info',
    editMenuPageTitle: 'Edit Menu Meal',
    addMenuPageTitle: 'New Menu Meal',
    addMenuPageFormEnglishTitle: 'Title',
    addMenuPageFormArabicTitle: 'Arabic Title',
    addMenuPageFormImage: 'Image',
    addMenuPageFormPrice: 'Price',
    addMenuPageFormArabicDescription: 'Arabic Description',
    addMenuPageFormDescription: 'Description',
    editRestaurantCategoryPageTitle: 'Edit Menu Category',
    addRestaurantCategoryPageFormTitle: 'New Menu Category',
    addRestaurantCategoryPageFormEnglishTitle: 'Title',
    addRestaurantCategoryPageFormArabicTitle: 'Arabic Title',
    addRestaurantCategoryPageFormImage: 'Image',
    // end restaurant add/edit category
    // end restaurant category
    // end restaurants tab
    // Start Banner Ads tab
    bannerAdsTab: 'Banner Ads Management',
    bannerAdsListPageTitle: 'Banner Ads Management',
    bannerAdsListTitleColumnTitle: 'Title',
    bannerAdsListStatusColumnTitle: 'Status',
    bannerAdsListEditColumnTitle: 'Edit',
    bannerAdsListAddButton: 'Add',
    bannerAdsStartDateTitle: 'Start date',
    bannerAdsEndtDateTitle: 'End date',
    bannerAdsListNoAdsMessage: 'There are no Ads yet. Please add one now',
    bannerAdsTypeListFieldTitle: 'Select ad type',
    bannerAdsEntityTypeListFieldTitle: 'Select ad category',
    bannerAdsEntityContentListFieldTitle: 'Select item',
    editAdsPageTitle: 'Edit Ad',
    addAdsPageTitle: 'New Ad',
    adsFormTitle: 'Ad Info',
    editAdTitle: 'Ad Title',
    editAdTitleArabic: 'Ad Arabic Title',
    editAdLink: 'Ad Link',
    editAdTitleEnglish: 'Ad English Title',
    addAdPageFormImage: 'Image',
    addAdPageFormStatus: 'Status',
    addAdPageFormStatusPublishedLabel: 'Published',
    addAdPageFormStatusUnpublishedLabel: 'Unpublished',
    homeListPageTitle: 'Home Management',
    homeListCategoryColumnTitle: 'Home',
    homeListStatusColumnTitle: 'Status',
    homeListStatusActive: 'Active',
    homeListStatusInactive: 'Not active',
    homeListEditColumnTitle: 'View',
    homeListEditButton: 'Edit',
    bannerAdsListNotificationColumnTitle: 'Notification',
    homeListItemsColumnTitle: 'Items',
    homeListItemsButton: 'Items',
    homeListNoCategoriesMessage: 'There are no list yet. Please add one now',
    // Notifications
    notificationsListPageTitle: 'Notifications History',
    notificationsListTab: 'Notifications Management',
    notificationsListTitleColumnTitle: 'Title',
    notificationsListBodyColumnTitle: 'Body',
    notificationsListAudienceColumnTitle: 'Audience',
    notificationsListTypeColumnTitle: 'Type',
    notificationsScheduledSendTimeColumnTitle: 'Scheduled Send Time',
    notificationListCreatedAtColumnTitle: 'Created At',
    notificationsListResendColumnTitle: 'Resend',
    notificationsListSendNotificationButtonTitle: 'New Notification',
    notificationsListNoNotificationsMessage: 'There are no notifications sent.',
    // featured articles
    featuredArticlesCannotAddMessage: 'Cannot add more than three articles !',
    editFeaturedArticleTitle: 'Edit Featured Article',
    addFeaturedArticleTitle: 'Add Featured Article',
    featuredArticlesTab: 'Featured Articles',
    FeaturedArticlesStatusActive: 'Active',
    FeaturedArticlesStatusNotActive: 'Not Active',
    featuredArticlesEditButton: 'View',
    featuredArticlesTableTitleColumn: 'Featured Article Title',
    featuredArticlesTableTitleArabicColumn: 'Featured Article Arabic Title',
    featuredArticlesTableStatusColumn: 'Status',
    featuredArticlesTableEditColumn: 'View',
    featuredArticlesTableNotificationColumn: 'Notification',
    featuredArticlesPageTitle: 'Featured Articles Management',
    FeaturedArticlesLiveTabTitle: 'Live',
    FeaturedArticlesHistoryTabTitle: 'History',
    noFeatuerdArticlesMessage: 'There are no featured articles yet. Please add one now.',
    // start Facilities Groups tab
    FacilityPageFormFacilityGroup: 'Facility Groups',
    addFacilityGroupPageTitle: 'New Facility Group',
    facilityGroupListNoFacilitiesMessage: 'Empty Facility Group',
    facilitiesGroupsListPageTitle: 'Facility Group List',
    facilityGroupFormTitle: 'Facility Group Form',
    facilitiesGroupsListStatusActive: 'Active',
    facilitiesGroupsListStatusInActive: 'InActive',
    editFacilityGroupArabicTitle: 'Title',
    editFacilityGroupEnglishTitle: 'E Title',
    editFacilityGroupPageTitle: 'Edit Facility Group',
    addFacilityGroupImage: 'Facility Group Image',
    // start Facilities Categories tab
    facilitiesCategoriesTab: 'Branch Facilities Categories',
    facilitiesCategoriesListPageTitle: 'Branch Facilities Categories Management',
    facilitiesCategoriesListTitleColumnTitle: 'Title',
    facilitiesCategoriesListStatusColumnTitle: 'Status',
    facilitiesCategoriesListEditColumnTitle: 'Edit',
    facilitiesCategoriesListAddButton: 'Add',
    facilitiesCategoriesListNoCategoriesMessage: 'There are No Categories yet. Please add one now',
    facilitiesCategoriesListStatusActive: 'Active',
    facilitiesCategoriesListStatusInActive: 'Inactive',
    facilitiesCategoriesListDeactivationWarning: 'Deactivating this category will deactivate its facilities. Are you sure you want to deactivate it?',
    editFacilityCategoryPageTitle: 'Edit Category',
    addFacilityCategoryPageTitle: 'New Category',
    facilityCategoryFormTitle: 'Category Info',
    editFacilityCategoryTitle: 'Category Title',
    addFacilityCategoryImage: 'Category Image',
    editFacilityCategoryArabicTitle: 'Category Arabic Title',
    editFacilityCategoryEnglishTitle: 'Category English Title',
    addFacilityCategoryPageFormStatus: 'Status',
    facilitiesListBranchColumnTitle: 'Branch',
    STATISTICS_FACILITIES_BRANCH: 'Branch facilities rating statistics',
    STATISTICS_FACILITIES_AREA: 'Area facilities rating statistics',
    STATISTICS_FACILITY: 'facility rating statistics',
    // End Facilities Categories tab
    // Start Facilities Areas tab
    facilitiesAreasListPageTitle: 'Facility Areas',
    facilitiesAreasListAddButton: 'Add',
    facilitiesAreasListTitleColumnTitle: 'Title',
    facilitiesAreasListEditColumnTitle: 'Edit',
    facilitiesAreasListNoCategoriesMessage: 'No Facility Area yet',
    editFacilityAreaPageTitle: 'Edit Facility Area',
    addFacilityAreaPageTitle: 'Add Facility Area',
    facilityAreaFormTitle: 'Facility Area Info',
    facilitiesListGenerateColumnTitle: 'Generate QR',
    editFacilityAreaArabicTitle: 'Add Arabic Title',
    editFacilityAreaEnglishTitle: 'Add English Title',
    addFacilityAreaPageFormAvailableBranches: 'Available Branches',
    // End Facilities Categories tab

    // Start Facilities Forms tab
    facilitiesFormsListPageTitle: 'Facility Forms',

    // start gallery tab
    galleryTab: 'Gallery Management',
    galleryListPageTitle: 'Gallery Management',
    galleryListImageColumnTitle: 'Media',
    galleryListStatusColumnTitle: 'Status',
    galleryListOrderColumnTitle: 'Order',
    galleryListEditColumnTitle: 'Edit',
    galleryListAddButton: 'Add',
    galleryListNoImageMessage: 'There are no Image yet. Please add one now',
    galleryListStatusActive: 'Active',
    galleryListStatusInactive: 'Not active',
    editImagePageTitle: 'Edit Media',
    addImagePageTitle: 'New Media',
    imageFormTitle: 'Media Info',
    addImagePageFormImage: 'Image',
    addIconPageFormImage: 'Icon',
    addImagePageFormVideo: 'Video',
    // end galley tab
    // start staticText tab
    staticTextsKeysColumnTitle: 'Keys',
    staticTextsCategoryColumnTitle: 'category',
    staticTextsValueColumnTitle: 'Text',
    staticTextsEditColumnTitle: 'Edit',
    editStaticTextPageTitle: 'Edit Static Text',
    addStaticTextPageTitle: 'Add Static Text',
    addStaticTextPageFormTitle: 'Static Text Info',
    addStaticTextPageFormKey: 'Text Key',
    addStaticTextPageFormDescription: 'Text description',
    addStaticTextPageFormValue: 'Text value',
    // end staticText tab
    // start deglawy featured tab
    deglawyFeaturedTab: 'Featured Management',
    deglawyFeaturesListPageTitle: 'Deglawy Featured Management',
    deglawyFeaturedListTitleColumnTitle: 'Title',
    deglawyFeaturedListPointsColumnTitle: 'Points',
    deglawyFeaturedListStatusColumnTitle: 'Status',
    deglawyFeaturedListEditColumnTitle: 'Edit',
    deglawyFeaturedListAddButton: 'Add',
    deglawyFeaturedListNoImageMessage: 'There are no deglawy Featured yet. Please add one now',
    deglawyFeaturedListStatusActive: 'Active',
    deglawyFeaturedListStatusInactive: 'Not active',
    // start deglawy featured form
    editDeglawyFeaturedPageTitle: 'Edit Deglawy Featured',
    addDeglawyFeaturedPageTitle: 'Add Deglawy Featured',
    deglawyFeaturedPageFormInfo: 'Deglawy Featured Info',
    deglawyFeaturedPageFormTitle: 'Title',
    deglawyFeaturedPageFormArabicTitle: 'Arbic Title',
    deglawyFeaturedPageFormPoints: 'Points',
    deglawyFeaturedPageFormPreview: 'Preview',
    deglawyFeaturedPageFormArabicPreview: 'Arabic Preview',
    deglawyFeaturedPageFormDescription: 'Description',
    deglawyFeaturedPageFormArabicDescription: 'Arabic Description',
    // end deglawy featured form
    // end deglawy featured tab
    // start deglawy trophies tab
    deglawyTrophyTab: 'Trophy Management',
    deglawyTrophiesListPageTitle: 'Deglawy Trophy Management',
    deglawyTrophyListTitleColumnTitle: 'Title',
    deglawyTrophyListPointsColumnTitle: 'Points',
    deglawyTrophyListStatusColumnTitle: 'Status',
    deglawyTrophyListEditColumnTitle: 'Edit',
    deglawyTrophyListAddButton: 'Add',
    deglawyTrophyListNoImageMessage: 'There are no deglawy Trophy yet. Please add one now',
    // start deglawy trophy form
    editDeglawyTrophyPageTitle: 'Edit Deglawy Trophy',
    addDeglawyTrophyPageTitle: 'Add Deglawy Trophy',
    deglawyTrophyPageFormInfo: 'Deglawy Trophy Info',
    deglawyTrophyPageFormTitle: 'Title',
    deglawyTrophyPageFormArabicTitle: 'Arabic Title',
    deglawyTrophyPageFormPoints: 'Points',
    deglawyTrophyPageFormActiveImage: 'Active Image',
    deglawyTrophyPageFormDimmedImage: 'Dimmed Image',
    deglawyTrophyPageFormErrorCode: 'Dimmed Image',
    deglawyTrophyErrorMessageTrophyWithSamePoints: 'Sorry there is already a trophy with the same points',
    deglawyTrophyUpdatedMessage: 'Updated trophy successfully',
    deglawyTrophyCreatedMessage: 'Created trophy successfully',
    // end deglawy trophy form
    // end deglawy trophies tab

    // start deglawyContent tab
    deglawyContentsTitlesColumnTitle: 'Titles',
    deglawyContentsEditColumnTitle: 'Edit',
    editDeglawyContentPageTitle: 'Edit Deglawy Content',
    addDeglawyContentPageTitle: 'Add Deglawy Content',
    addDeglawyContentPageFormTitle: 'Deglawy Content Info',
    addDeglawyPortalContentPageFormTitle: 'Deglawy Portal Content Info',
    addDeglawyContentPageFormKey: 'Content Title',
    addDeglawyContentPageFormBody: 'Content Body',
    addDeglawyContentPageFormImage: 'Header Image',
    deglawyPortalTab: 'Portal Content Management',
    // end deglawyContent tab

    // start facility tab
    ratingFacilityReportFacilityName: "Facility Name",
    ratingFacilityReportCategoryName: "Category Name",
    ratingFacilityReportBranchName: "Branch Name",
    ratingFacilityReportAreaName: "Area Name",
    ratingFacilityReportRating: "Rating",
    facilityResponseNameColumn: 'Name',
    facilityResponseMembershipColumn: 'Membership',
    facilityResponseRatingColumn: 'Rating',
    facilityResponseDetailsColumn: 'Details',

    //gates
    gatesListPageTitle: "Gates Management",
    gatesListFacilityColumnTitle: "Title",
    gatesListBranchColumnTitle: "Branch",
    gatesListNoGatesMessage: "No Gates",
    gatesListEditColumnTitle: "Edit",
    editGatePageTitle: "Edit Gate",
    addGatePageTitle: "New Gate",
    addGatePageFormTitle: "Add New Gate",
    GatePageFormAvailableBranches: "Branch",

    facilityManagementTab: 'Branch Facilities',
    facilitiesListPageTitle: 'Facilities Management',
    facilitiesListFacilityColumnTitle: 'Facility',
    facilitiesListStatusColumnTitle: 'Status',
    facilitiesListEditColumnTitle: 'Edit',
    FacilityPageFormFacilityAreas: 'Facility Areas',
    FacilityPageFormFacilityForms: 'Facility Forms',
    facilitiesListNoFacilitiesMessage: 'There are No Facilities yet. Please add one now',
    FacilityPageFormTitle: 'Facility Info',
    editFacilityPageTitle: 'Edit Facility',
    addFacilityPageTitle: 'Add Facility',
    FacilityPageFormTitleLabel: 'Title',
    FacilityPageFormArabicTitleLabel: 'Arabic Title',
    FacilityPageFormAvailableBranches: 'Facility Available Branches',
    FacilityPageFormFacilityCategories: 'Facility Categories',
    FacilityPageFormActiveLabel: 'Active',
    FacilityPageFormNotActiveLabel: 'Not Active',
    FacilityPageFormStatus: 'Status',
    facilitiesListEditButton: 'Edit',
    // end facility tab
    // start settings Tab
    settingsListNoSettingsMessage: 'There are no configurations yet.',
    customerServiceManagement: 'CS Working Hours ',
    hours: 'Hours',
    open: 'Open',
    closed: 'Closed',
    Submit: 'Submit',
    invalidValue: 'Invalid Input',
    workingHoursSavedSuccessfully: "Working Hours Updated Successfully",
    errorSavingWorkingHours: "Error while saving working hours",
    settingsListPageTitle: 'Settings Management',
    settingsListKeyColumnTitle: 'Key',
    settingsListValueColumnTitle: 'Value',
    settingsListEditColumnTitle: 'Edit',
    editSettingsPageTitle: 'Edit Setting',
    addSettingPageFormTitle: 'Setting Info',

    // start statistics Tab
    createWallet: 'Create Wallet',
    DetailedStatisticsTabTitle: 'Detailed Statistics',
    UsersTableTabTitle: 'Users',
    NotRegisteredUsersTabTitle: 'Not Registered Users',
    SuspendUsers: 'Suspended Users',
    statisticsListNameColumnTitle: 'Name',
    statisticsListMemberShipColumnTitle: 'Membership ID',
    statisticsListPhoneNumberColumnTitle: 'Phone Number',
    statisticsListIsMainMemberColumnTitle: 'Main Member',
    preRegisteredListVerificationCodeColumnTitle: 'Code',
    preRegisteredListMemberShipColumnTitle: 'Membership ID',
    preRegisteredListPhoneNumberColumnTitle: 'Phone Number',
    PreRegisteredListNoUsersMessage: 'There are no users Yet.',

    // Featured Offer Tab
    FeaturedOfferManagementTab: 'Featured Offer Management',
    FeaturedOfferPageTitle: 'Featured Offer Management',
    FeaturedOfferListImageColumnTitle: 'Offer',
    FeaturedOfferListTitleColumnTitle: 'Title',
    FeaturedOfferListHotDealColumnTitle: 'Hot Deal',
    FeaturedOfferListOrderColumnTitle: 'Order',
    FeaturedOfferListEditColumnTitle: 'Edit',
    FeaturedOfferListAddButton: 'Add',
    FeaturedOfferListNoImageMessage: 'There are no featured offer yet. Please add one',
    FeaturedOfferAddForm: 'Available Offers',
    FeaturedOfferEditPageTitle: 'Edit Offer',
    FeaturedOfferAddPageTitle: 'New Offer',
    FeaturedOfferFormTitle: 'Offer Info',
    // Featured Offer Tab


    //general ads
    generalAdsListTitle: 'General Ads',
    generalAdsEmptyMessage: 'There are no general ads',
    generalAdsTitleColumnTitle: 'Title',
    generalAdsIsActiveColumnTitle: 'Active',
    generalAdsEditColumnTitle: 'Edit',
    activateGeneralAdAlert: 'Activating this ad will deactivate other ads. Do you agree?',
    editGeneralAdPageTitle: 'Edit General Ad',
    newGeneralAdPageTitle: 'Add New General Ad',
    generalAdPageFormTitle: 'General Ad Form',
    generalAdTitleInuptArabicTitle: 'Arabic Title',
    generalAdVideoInuptArabicTitle: 'Upload Video',
    generalAdImageURL_arPageFormImage: 'Upload Image for arabic users',
    generalAdImageURL_enPageFormImage: 'Upload Image for english users',
    filesConflictError: 'Your are allowed to attach only video or images for both arabic and english users',
    generalWidgetImageURL_arPageFormImage: 'Widget image for Arabic users',
    generalWidgetImageURL_enPageFormImage: 'Widget image for English users',

    // statistics Tab
    PORTAL_USERS: 'Portal Users',
    MOBILE_USERS: 'Mobile Users',
    SPORTS_USERS: 'Sports Users',
    UNKNOWN_USERS: 'Unknown Users',
    STATISTICS_USERS: 'Users Statistics',
    TOTAL_USERS: 'Total Users:',
    USERS_FROM_PORTAL: 'Users From Portal:',
    USERS_FROM_MOBILE: 'Users From Mobile:',
    USERS_FROM_SPORTS: 'Users From Sports Reservations:',
    USERS_FROM_UNKNOWN: 'Users From Unknown Sources:',
    addCalenderSepratorPageFormTitle: 'Add Calender Seprator',
    addCalenderSepratorPageTitle: 'Add Calender Seprator',
    editCalenderSepratorPageTitle: 'Edit Calender Seprator',
    addCalenderSepratorPageFormName: 'Calender Seprator Title',
    addCalenderSepratorPageFormGallery: 'Calender Seprator Image',
    addCalenderSepratorPageFormDate: 'Calender Seprator Date',
    editEventCategoryPageTitle: 'Edit Event Category',
    addEventCategoryPageTitle: 'Add Event Category',
    addEventCategoryPageFormTitle: 'Add Event Category',
    addEventCategoryPageFormName: 'event category title',
    addEventPageFormName: 'Event Title',
    addEventPageFormGallery: 'Event Image',
    addEventPageFormStartDate: 'Event Start Date',
    addEventPageFormEndDate: 'Event End Date',
    editEventPageTitle: 'Edit Event',
    addEventPageTitle: 'Add Event',
    addEventPageFormDescription: 'Event Description',
    addEventPageFormCategory: 'Event Category',
    addEventPageFormAllDay: 'All Day',
    addEventPageFormStatus: 'Status',
    addEventPageFormStatusActiveLabel: 'Active',
    addEventPageFormStatusInactiveLabel: 'Not active',
    Suspended: 'Suspended',
    UnSuspended: 'unsuspended',
    Suspend: 'Suspend',
    UnSuspend: 'unsuspend',
    SuspendedStatus: 'Status',
    offersListNoMessage: 'There are no offers yet. Please add one now',
    offersListPageTitle: 'Offers Management',
    offersListTitleColumnTitle: 'Title',
    offersListEditColumnTitle: 'Edit',
    steps: 'Steps',
    terms: 'Terms and Conditions',
    offerFormTitle: 'Offer',
    editOfferPageTitle: 'Edit Offer',
    addOfferPageTitle: 'New Offer',
    HotDeal: 'Hot Deal',
    DiscountPercentage: 'dicount percentage',
    NotHotDeal: 'Not Hot Deal',
    totalRgistred: 'Total registered users',
    totalMobileUsers: 'Total mobile users',
    totalWebUsers: 'Total web portal users',
    totalSportsUsers: 'Total sports reservation users',
    totalUnknownUsers: 'Total unknown sources users',
    wifiPackagesPageTitle: 'Wifi Packages',
    editWifiPackagePageTitle: 'Edit Wifi Package',
    addWifiPackagePageTitle: 'Add Wifi Package',
    TRANSACTIONS_RE_NOTIFY_DIALOG_TITLE: 'Renotify sap transaction',
    TRANSACTIONS_RE_NOTIFY_DIALOG_CONTENT: 'Are you sure you want to renotify successful transaction ?',
    sapTransactionsLogs: 'Sap transactions logs',
    sapLogsErrorBlocked: 'blocked or deleted',
    sapLogsErrorPaidBefore: 'already paid',
    sapLogsErrorNoOpenItems: 'there is no open items',
    sapLogsErrorPaid: 'paid',
    sapLogsErrorSomethingwrong: 'something error',
    surveyPageTitle: 'Survey',
    editSurveyPageTitle: 'Edit Survey',
    addSurveyPageTitle: 'Add Survey',
    downloadButton: 'Download Report',
    limitedUsersTab: 'LIMITED USERS',
    accessLevel: 'Access Level',
    limited: 'Limited',
    full: 'Full',
    syncUserStatus: 'Sync',
    verified: "Verified",
    membershipId: "Membership Id ex. 00200_1",
    selected: "Selected",
    phoneSelection: "Phone selection",
    verify: "Verify",
    registred: "Registred",
    addAccumulation: 'Add online user accumulation',
    updatePhone: "update phone number",
    updatePhoneLabel: "Wallet phone number start with country code ex. +20",
    points: "Points",
    physical: "physical",
    bulkSeed: "Bulk seed",
    details: "details",
    renewalsDetails: "Renewals Details",
    wifiPayment: "wifi Packages payment",
    fawryLogs: "Fawry logs",
    orangeLogs: "Orange logs",
    transactions: "transactions",
    wifiSubscriptions: "Wifi packages subscriptions",
    noSearchWord: "Please enter correct search word",
    deglawyPoints: 'Deglawy points',
    selectWidget: "Please select a widget to start editing.",

    // Facebook
    fbTableTitle: 'Users\' Facebook Info',
    fbEmptyTableMessage: 'No Facebook Profiles Connected Yet',
    fbDownloadSheet: 'Download As Excel Sheet',
    errorDownloadingFile: 'Error downloading file. Try again later',
    WIFI_PACKAGE: "Wifi package",

    // Release notes
    releaseNotesTableTitle: 'Release Notes',
    releaseNotesEmptyTableMessage: 'No release notes available',
    notificationsListActiveInActiveColumnTitle: "Cancel schedule",

    deliveryRegionsTableTitle: 'Delivery Regions',
    deliveryRegionsEmptyTableMessage: 'No delivery regions available',
    cardsDeliveryTableTitle: 'Cards Delivery Requests',
    viewAddressButton: 'Address Details',
    NEW: 'New',
    NoAction: "Nothing Happening",
    OtpSent: "Your Code is on the Way!",
    CalimedPoints: "Points Successfully Claimed!",
    LeadsEmptyTableMessage: "No leads were found matching your criteria."

  },
  ar: {
    hello: 'اهلا بك',
    customerServiceManagement: 'خدمة العملاء',
    hours: 'ساعات العمل',
    open: 'مفتوح',
    closed: 'مغلق',
    Submit: 'حفظ',
    invalidValue: 'غير صحيح',
    workingHoursSavedSuccessfully: "تم الحفظ بنجاح",
    errorSavingWorkingHours: "حدث خطا اثناء الحفظ",
    staticTextsValueColumnTitle: 'النص',

    //general ads
    generalAdsListTitle: 'الاعلان العام',
    generalAdsEmptyMessage: 'لا يوجد اعلانات',
    generalAdsTitleColumnTitle: 'العنوان',
    generalAdsIsActiveColumnTitle: 'مفعل',
    generalAdsEditColumnTitle: 'تعديل',
    activateGeneralAdAlert: 'تفعيل هذا الاعلان سوف يعطل باقى الاعلانات. هل توافق؟',
    editGeneralAdPageTitle: 'تعديل',
    newGeneralAdPageTitle: 'اعلان جديد',
    generalAdPageFormTitle: 'إضافة اعلان جديد',
    generalAdTitleInuptArabicTitle: 'العنوان',
    generalAdVideoInuptArabicTitle: 'تحميل فيديو',
    generalAdImageURL_arPageFormImage: 'تحميل صوره للنسخه العربيه',
    filesConflictError: 'مسموح فقط تحميل فيديو او صوره لكل من المستخدمين باللغع العربيه واللغه الانجليزيه',
    generalAdImageURL_enPageFormImage: 'تحميل صوره للنسخه الانجليزيه',
    generalWidgetImageURL_arPageFormImage: 'صورة الاعلان النسخه العربيه',
    generalWidgetImageURL_enPageFormImage: 'صورة الاعلان النسخه الانجليزيه',

    facilitiesListBranchColumnTitle: 'الفرع',

    screenTitle: 'شاشه الدخول',
    email: 'الحساب',
    emailNotValid: 'الرجاء ادخال حساب صحيح',
    password: 'كلمه السر',
    loginError: 'حساب او كلمه سر غير صحيح',
    loginButton: 'دخول',
    forgotPasswordButton: 'نسيت كلمه السر',
    // featured articles
    editFeaturedArticleTitle: 'تعديل مقال مميز',
    addFeaturedArticleTitle: 'إضافة مقال مميز',
    featuredArticlesTab: 'مقالات مميزة',
    FeaturedArticlesStatusPublished: 'منشور',
    FeaturedArticlesStatusUnpublished: 'غير منشور',
    featuredArticlesEditButton: 'عرض',
    featuredArticlesTableTitleColumn: 'عنوان المقال المميز',
    featuredArticlesTableStatusColumn: 'الحالة',
    featuredArticlesTableEditColumn: 'عرض',
    featuredArticlesPageTitle: 'إدارة المقالات المميزة',
    noFeatuerdArticlesMessage: 'لا يوجد مقالات مميزة بعد. برجاء إضافة واحد الآن.',
    Suspended: 'Suspended',
    UnSuspended: 'unsuspended',
    Suspend: 'Suspend',
    UnSuspend: 'unsuspend',
    SuspendedStatus: 'Status',
    title: 'Arabic Title',
    description: 'Arabic Description',
    // start general
    addButton: 'Add',
    editButton: 'تعديل',
    updatedMessage: 'Updated Successfully',
    delete: 'حذف',
    deleteAlert: "Are you sure you want to delete ?",
    deletedMessage: 'Deleted Successfully',
    errorMessage: 'Something Went Wrong',
    copyMessage: 'Copied Successfully',
    name: 'name',
    action: 'Action',
    emptyTable: 'there is no data',
    FormActiveLabel: 'مُفعل',
    FormNotActiveLabel: 'غير مُفعل',
    Status: 'Status',
    wdcBranchRequiredErrorMessage: 'WDC Branch Required',
    createdMessage: 'Created Successfully',
    about: 'About',
    easyfinance: 'EZ Finance',
    partnersAbout: 'Partners About',
    offersAbout: 'Offers About',
    // end general
    loginScreen: {
      screenTitle: 'Login',
      email: 'Email',
      emailNotValid: 'Please enter a valid email',
      password: 'Password',
      loginError: 'Invalid email or password',
      loginButton: 'Login',
      forgotPasswordButton: 'Forgot Password ?',
      forgotPasswordEnterEmailMessage: 'Enter Your Email Address',
      emailSentSuccessMessage: 'An Email has been Sent Containing the Link to Reset your Password\n'
          + 'Please Access your Email to Continue with the Reset Process',
      passwordValidationMessage: 'Password has to be at least 8 characters!',
      requestConfirmation: 'Password confirmation is required!',
      resetPasswordSuccess: 'You have Successfully changed your password you can now Login using your new password',
    },
    // start Branches tab
    branchesTab: 'Branches Management',
    editBranchPageTitle: 'Edit Branch',
    addBranchPageTitle: 'New Branch',
    addBranchPageFormTitle: 'Branch Info',
    addBranchPageFormEnglishName: 'Branch English Name',
    addBranchPageFormArabicName: 'Branch Arabic Name',
    addBranchPageFormWaterfrontType: 'Waterfront',
    addBranchPageFormClubType: 'Club',
    addBranchPageFormArabicDescription: 'Branch Arabic Description',
    addBranchPageFormEnglishDescription: 'Branch English Description',
    addBranchPageFormBranchLocation: 'Branch Location',
    addBranchPageFormWdcBranch: 'Select WDC Branch',
    addBranchPageFormBackgroundImage: 'Background Image',
    addBranchPageFormGalleryImages: 'Gallery Images',
    addBranchPageFormGalleryVideos: 'Gallery Videos',
    addBranchPageFormGalleryImages360: 'Gallery 360 Images',
    addBranchPageFormMasterPlanImage: 'Master Plan Image',
    addBranchPageFormMasterPlanWarningMessage: 'Aspect Ratio should be 16:9',
    addBranchPageFormFeatures: 'Features',
    addVideoTextMessage: 'Try dropping some files here, or click to select files to upload.',
    addImageErrorMessage: 'Image size exceeds the limit',
    addImageSuccessMessage: 'Image was uploaded successfully',
    // use String.prototype.replace('_SIZE_', "SIZE IN KB") with the following two strings:
    addBranchPageFormDropzoneTextMessage: 'Try dropping some files here, or click to select files to upload. (Max _SIZE_ KB)',
    addBranchPageFormMasterPlanTextMessage: 'Try dropping some files here, or click to select files to upload. (Max _SIZE_ KB)',
    // branch features
    branchFeatureTableTitle: 'Branch Features',
    branchFeatureEmptyTableMessage: 'No features found',
    // End Branches tab
    academiesTab: 'Management',
    // start add/edit article
    editAcademyPageTitle: 'Edit Academy',
    addAcademyPageTitle: 'New Academy',
    addAcademyPageFormTitle: 'Academy Info',
    addAcademyPageFormEnglishName: 'Name',
    addAcademyPageFormArabicName: 'Arabic Name',
    addAcademyPageFormEnglishDescription: 'Description',
    addAcademyPageFormArabicDescription: 'Arabic Description',
    addAcademyPageFormAvailableBranches: 'Academy Available Branches',
    addAcademyPageFormGallery: 'Gallery',
    addAcademyPageFormPreviewImage: 'Preview Card Thumbnail',
    addAcademyPageFormBackgroundImage: 'Details Page Background Thumbnail',
    addAcademyPageFormStatus: 'Status',
    addAcademyPageFormStatusActiveLabel: 'Active',
    addAcademyPageFormStatusInactiveLabel: 'Not active',
    addAcademyPageFormAcademyCategories: 'Academy News Categories',
    addAcademyPageFormSports: 'Available Sports',
    wdcAcademyRequiredErrorMessage: 'WDC Academy is required!',
    // end add/edit article
    // start news tab
    newsTab: 'News Management',
    newsListPageTitle: 'News Management',
    newsListArticleColumnTitle: 'Article',
    newsListStatusColumnTitle: 'Status',
    newsListCategoryColumnTitle: 'Category',
    newsListLiveColumnTitle: 'Live Status',
    newsListStartDateColumnTitle: 'Start Date',
    newsListEndDateColumnTitle: 'End Date',
    newsListStatusActive: 'Active',
    newsListStatusInactive: 'Not Active',
    newsListEditColumnTitle: 'Edit',
    newsListEditButton: 'Edit',
    newsListNoArticlesMessage: 'There are no articles yet. Please add one now',
    newsListClearFiltersButton: 'Clear Filters',
    newsListDynamicLink: 'Deep Link',
    newCopyDynamicLink: 'Copy',
    newGenerateDynamicLink: 'Generate',
    featuredNewsListDeactivationWarning:
        'This Article is a Featured Article are you sure you want to Deactivate It Deactivating is a Permenant Action and Can not be undone ?',
    homeTileNewsListDeactivationWarning:
        'This Article is a Home Tile Article are you sure you want to Deactivate It Deactivating is a Permenant Action and Can not be undone ?',
    homeTileAndFeaturedNewsListDeactivationWarning:
        'This Article is a Featured and Home Tile Article are you sure you want to Deactivate It Deactivating is a Permenant Action and Can not be undone ?',
    // start add/edit article
    editArticlePageTitle: 'Edit Article',
    addArticlePageTitle: 'New Article',
    addArticlePageFormTitle: 'Article Info',
    addArticlePageFormArticleTitle: 'Title',
    addArticlePageFormArticleArabicTitle: 'Arabic Title',
    addArticlePageFormPreview: 'Preview',
    addArticlePageFormArabicPreview: 'Arabic Preview',
    addArticlePageFormDescription: 'Description',
    addArticlePageFormArabicDescription: 'Arabic Description',
    addArticlePageFormCategory: 'Category',
    addArticlePageFormImage: 'Image',
    addArticlePageFormVideo: 'Video',
    addArticlePageFormWarningImageMessage: 'Warning: Article will be published with WDC Logo',
    addArticlePageFormAutoScheduled: 'AutoScheduled',
    addArticlePageFormAutoScheduledOffLabel: 'AutoScheduled On',
    addArticlePageFormAutoScheduledOnLabel: 'AutoScheduled Off',
    addArticlePageFormStatus: 'Status',
    addArticlePageFormStatusPublishedLabel: 'Active',
    addArticlePageFormStatusUnpublishedLabel: 'not Active',
    addArticlePageFormStartDate: 'Start Date',
    addArticlePageFormEndDate: 'End Date',
    // end add/edit article
    // end news tab
    // Start Academies Announcements tab
    academiesAnnouncementsTab: 'Announcements',
    announcementListPageTitle: 'Academies Announcements',
    addAnnouncementPageFormTitle: 'Announcement Info',
    announcementListNoArticlesMessage: 'There are no Articles yet. Please add one now',
    academiesAnnouncementsTabEditAnnouncement: 'Edit Announcement',
    academiesAnnouncementsTabAddAnnouncement: 'Add Announcement',
    academiesAnnouncementsListNoCategoriesMessage: 'There are no Articles yet. Please add one now',
    academiesAnnouncementsFormArticleNameEn: 'ARTICLE NAME',
    editAcademiesAnnouncementsArticleLayoutImages: 'ARTICLE LAYOUT IMAGES',
    academiesAnnouncementsFormArticleNameAr: 'ARTICLE NAME',
    editAcademiesAnnouncementsArticlePreview: 'ARTICLE PREVIEW',
    // end Academies Announcements tab
    // start news Categories tab
    newsCategoriesTab: 'News Categories Management',
    newsCategoriesListPageTitle: 'News Categories Management',
    newsCategoriesListCategoryColumnTitle: 'Category',
    newsCategoriesListEditColumnTitle: 'Edit',
    newsCategoriesListEditButton: 'Edit',
    newsCategoriesListAddButton: 'Add',
    newsCategoriesListNoCategoriesMessage: 'There are no Categories yet. Please add one now',
    editNewsCategoryPageTitle: 'Edit Category',
    addNewsCategoryPageTitle: 'New Category',
    newsCategoryFormTitle: 'Category Info',
    editNewsCategoryTitleEn: 'Category Title',
    editNewsCategoryTitleArabic: 'Category Arabic Title',
    editNewsCategoryTitleAr: 'Category Title',
    // end News Categories tab
    // start restaurants tab
    restaurantsTab: 'Restaurants Management',
    restaurantsListPageTitle: 'Restaurants Management',
    restaurantsListRestaurantColumnTitle: 'Restaurant',
    restaurantsListStatusColumnTitle: 'Status',
    restaurantsListStatusActive: 'Active',
    restaurantsListStatusInactive: 'Not active',
    restaurantsListEditColumnTitle: 'Edit',
    restaurantsListEditButton: 'Edit',
    restaurantsListEditColumnMenu: 'Menu',
    restaurantsListMenuButton: 'Menu',
    restaurantsListNoRestaurantsMessage: 'There are no restaurants yet. Please add one now',
    // start add/edit restaurant
    editRestaurantPageTitle: 'Edit Restaurant',
    addRestaurantPageTitle: 'New Restaurant',
    addRestaurantPageFormTitle: 'Restaurant Info',
    addRestaurantPageFormEnglishTitle: 'Title',
    addRestaurantPageFormArabicTitle: 'Arabic Title',
    addRestaurantPageFormEnglishDescription: 'Description',
    addRestaurantPageFormArabicDescription: 'Arabic Description',
    addRestaurantPageFormAvailableBranches: 'Available Branches',
    addRestaurantPageFormLogo: 'Logo',
    addRestaurantPageFormImages: 'Gallery',
    // end add/edit restaurant
    // start restaurant category
    restaurantCategoriesListPageTitle: 'Categories Management',
    restaurantCategoriesListCategoryColumnTitle: 'Category',
    restaurantCategoriesListStatusColumnTitle: 'Status',
    restaurantCategoriesListStatusActive: 'Active',
    restaurantCategoriesListStatusInactive: 'Not active',
    restaurantCategoriesListEditColumnTitle: 'Edit',
    restaurantCategoriesListEditButton: 'Edit',
    restaurantCategoriesListItemsColumnTitle: 'Items',
    restaurantCategoriesListItemsButton: 'Items',
    restaurantCategoriesListNoCategoriesMessage: 'There are no categories yet. Please add one now',
    // start restaurant category
    menuListPageTitle: 'Menu Management',
    menuListCategoryColumnTitle: 'Menu',
    menuListStatusColumnTitle: 'Status',
    menuListPriceColumnTitle: 'Price',
    menuListStatusActive: 'Active',
    menuListStatusInactive: 'Not active',
    menuListEditColumnTitle: 'Edit',
    menuListEditButton: 'Edit',
    menuListItemsColumnTitle: 'Items',
    menuListItemsButton: 'Items',
    menuListNoCategoriesMessage: 'There are no menu yet. Please add one now',
    // start restaurant add/edit category
    addMenuPageFormTitle: 'Menu Info',
    editMenuPageTitle: 'Edit Menu Meal',
    addMenuPageTitle: 'New Menu Meal',
    addMenuPageFormEnglishTitle: 'Title',
    addMenuPageFormArabicTitle: 'Arabic Title',
    addMenuPageFormImage: 'Image',
    addMenuPageFormPrice: 'Price',
    addMenuPageFormArabicDescription: 'Arabic Description',
    addMenuPageFormDescription: 'Description',
    editRestaurantCategoryPageTitle: 'Edit Menu Category',
    addRestaurantCategoryPageFormTitle: 'New Menu Category',
    addRestaurantCategoryPageFormEnglishTitle: 'Title',
    addRestaurantCategoryPageFormArabicTitle: 'Arabic Title',
    addRestaurantCategoryPageFormImage: 'Image',
    // end restaurant add/edit category
    // end restaurant category
    // end restaurants tab
    // Start Banner Ads tab
    bannerAdsTab: 'Banner Ads Management',
    bannerAdsListPageTitle: 'Banner Ads Management',
    bannerAdsListTitleColumnTitle: 'Title',
    bannerAdsListStatusColumnTitle: 'Status',
    bannerAdsListEditColumnTitle: 'Edit',
    bannerAdsListAddButton: 'Add',
    bannerAdsStartDateTitle: 'Start date',
    bannerAdsEndtDateTitle: 'End date',
    bannerAdsListNoAdsMessage: 'There are no Ads yet. Please add one now',
    bannerAdsTypeListFieldTitle: 'Select ad type',
    bannerAdsEntityTypeListFieldTitle: 'Select ad category',
    bannerAdsEntityContentListFieldTitle: 'Select item',
    editAdsPageTitle: 'Edit Ad',
    addAdsPageTitle: 'New Ad',
    adsFormTitle: 'Ad Info',
    editAdTitle: 'Ad Title',
    editAdTitleArabic: 'Ad Arabic Title',
    editAdLink: 'Ad Link',
    editAdTitleEnglish: 'Ad English Title',
    addAdPageFormImage: 'Image',
    addAdPageFormStatus: 'Status',
    addAdPageFormStatusPublishedLabel: 'Published',
    addAdPageFormStatusUnpublishedLabel: 'Unpublished',
    homeListPageTitle: 'Home Management',
    homeListCategoryColumnTitle: 'Home',
    homeListStatusColumnTitle: 'Status',
    homeListStatusActive: 'Active',
    homeListStatusInactive: 'Not active',
    homeListEditColumnTitle: 'View',
    homeListEditButton: 'Edit',
    bannerAdsListNotificationColumnTitle: 'Notification',
    homeListItemsColumnTitle: 'Items',
    homeListItemsButton: 'Items',
    homeListNoCategoriesMessage: 'There are no list yet. Please add one now',
    // Notifications
    notificationsListPageTitle: 'Notifications History',
    notificationsListTab: 'Notifications Management',
    notificationsListTitleColumnTitle: 'Title',
    notificationsListBodyColumnTitle: 'Body',
    notificationsListAudienceColumnTitle: 'Audience',
    notificationsListTypeColumnTitle: 'Type',
    notificationsScheduledSendTimeColumnTitle: 'Scheduled Send Time',
    notificationListCreatedAtColumnTitle: 'Created At',
    notificationsListResendColumnTitle: 'Resend',
    notificationsListSendNotificationButtonTitle: 'New Notification',
    notificationsListNoNotificationsMessage: 'There are no notifications sent.',
    // featured articles
    featuredArticlesCannotAddMessage: 'Cannot add more than three articles !',
    FeaturedArticlesStatusActive: 'Active',
    FeaturedArticlesStatusNotActive: 'Not Active',
    featuredArticlesTableTitleArabicColumn: 'Featured Article Arabic Title',
    featuredArticlesTableNotificationColumn: 'Notification',
    FeaturedArticlesLiveTabTitle: 'Live',
    FeaturedArticlesHistoryTabTitle: 'History',
    // start Facilities Categories tab

    facilitiesCategoriesTab: 'Branch Facilities Categories',
    facilitiesCategoriesListPageTitle: 'Branch Facilities Categories Management',
    facilitiesCategoriesListTitleColumnTitle: 'Title',
    facilitiesCategoriesListStatusColumnTitle: 'Status',
    facilitiesCategoriesListEditColumnTitle: 'Edit',
    facilitiesCategoriesListAddButton: 'Add',
    facilitiesCategoriesListNoCategoriesMessage: 'There are No Categories yet. Please add one now',
    facilitiesCategoriesListStatusActive: 'Active',
    facilitiesCategoriesListStatusInActive: 'Inactive',
    facilitiesCategoriesListDeactivationWarning: 'Deactivating this category will deactivate its facilities. Are you sure you want to deactivate it?',
    // start Facilities Groups tab
    FacilityPageFormFacilityGroup: 'Facility Groups',
    addFacilityGroupPageTitle: 'New Facility Group',
    facilityGroupListNoFacilitiesMessage: 'Empty Facility Group',
    facilitiesGroupsListPageTitle: 'Facility Group List',
    facilityGroupFormTitle: 'Facility Group Form',
    facilitiesGroupsListStatusActive: 'Active',
    facilitiesGroupsListStatusInActive: 'InActive',
    editFacilityGroupArabicTitle: 'Title',
    editFacilityGroupEnglishTitle: 'E Title',
    editFacilityGroupPageTitle: 'Edit Facility Group',
    addFacilityGroupImage: 'Facility Group Image',
    // start Facilities Categories tab
    facilityCategoryFormTitle: 'Category Info',
    editFacilityCategoryTitle: 'Category Title',
    addFacilityCategoryImage: 'Category Image',
    editFacilityCategoryArabicTitle: 'Category Arabic Title',
    addFacilityCategoryPageFormStatus: 'Status',
    STATISTICS_FACILITIES_BRANCH: 'Branch facilities rating statistics',
    STATISTICS_FACILITIES_AREA: 'Area facilities rating statistics',
    STATISTICS_FACILITY: 'facility rating statistics',
    // End Facilities Categories tab
    // Start Facilities Areas tab
    facilitiesAreasListPageTitle: 'Facility Areas',
    facilitiesAreasListAddButton: 'Add',
    facilitiesAreasListTitleColumnTitle: 'Title',
    facilitiesAreasListEditColumnTitle: 'Edit',
    facilitiesAreasListNoCategoriesMessage: 'No Facility Area yet',
    editFacilityAreaPageTitle: 'Edit Facility Area',
    addFacilityAreaPageTitle: 'Add Facility Area',
    facilityAreaFormTitle: 'Facility Area Info',
    facilitiesListGenerateColumnTitle: 'Generate QR',
    editFacilityAreaArabicTitle: 'Add Arabic Title',
    editFacilityAreaEnglishTitle: 'Add English Title',
    addFacilityAreaPageFormAvailableBranches: 'Available Branches',
    // End Facilities Categories tab

    // Start Facilities Forms tab
    facilitiesFormsListPageTitle: 'Facility Forms',

    // start gallery tab
    galleryTab: 'Gallery Management',
    galleryListPageTitle: 'Gallery Management',
    galleryListImageColumnTitle: 'Media',
    galleryListStatusColumnTitle: 'Status',
    galleryListOrderColumnTitle: 'Order',
    galleryListEditColumnTitle: 'Edit',
    galleryListAddButton: 'Add',
    galleryListNoImageMessage: 'There are no Image yet. Please add one now',
    galleryListStatusActive: 'Active',
    galleryListStatusInactive: 'Not active',
    editImagePageTitle: 'Edit Media',
    addImagePageTitle: 'New Media',
    imageFormTitle: 'Media Info',
    addImagePageFormImage: 'Image',
    addIconPageFormImage: 'Icon',
    addImagePageFormVideo: 'Video',
    // end galley tab
    // start staticText tab
    staticTextsKeysColumnTitle: 'Keys',
    staticTextsCategoryColumnTitle: 'category',
    staticTextsEditColumnTitle: 'Edit',
    editStaticTextPageTitle: 'Edit Static Text',
    addStaticTextPageTitle: 'Add Static Text',
    addStaticTextPageFormTitle: 'Static Text Info',
    addStaticTextPageFormKey: 'Text Key',
    addStaticTextPageFormDescription: 'Text description',
    addStaticTextPageFormValue: 'Text value',
    // end staticText tab
    // start deglawy featured tab
    deglawyFeaturedTab: 'Featured Management',
    deglawyFeaturesListPageTitle: 'Deglawy Featured Management',
    deglawyFeaturedListTitleColumnTitle: 'Title',
    deglawyFeaturedListPointsColumnTitle: 'Points',
    deglawyFeaturedListStatusColumnTitle: 'Status',
    deglawyFeaturedListEditColumnTitle: 'Edit',
    deglawyFeaturedListAddButton: 'Add',
    deglawyFeaturedListNoImageMessage: 'There are no deglawy Featured yet. Please add one now',
    deglawyFeaturedListStatusActive: 'Active',
    deglawyFeaturedListStatusInactive: 'Not active',
    // start deglawy featured form
    editDeglawyFeaturedPageTitle: 'Edit Deglawy Featured',
    addDeglawyFeaturedPageTitle: 'Add Deglawy Featured',
    deglawyFeaturedPageFormInfo: 'Deglawy Featured Info',
    deglawyFeaturedPageFormTitle: 'Title',
    deglawyFeaturedPageFormArabicTitle: 'Arbic Title',
    deglawyFeaturedPageFormPoints: 'Points',
    deglawyFeaturedPageFormPreview: 'Preview',
    deglawyFeaturedPageFormArabicPreview: 'Arabic Preview',
    deglawyFeaturedPageFormDescription: 'Description',
    deglawyFeaturedPageFormArabicDescription: 'Arabic Description',
    // end deglawy featured form
    // end deglawy featured tab
    // start deglawy trophies tab
    deglawyTrophyTab: 'Trophy Management',
    deglawyTrophiesListPageTitle: 'Deglawy Trophy Management',
    deglawyTrophyListTitleColumnTitle: 'Title',
    deglawyTrophyListPointsColumnTitle: 'Points',
    deglawyTrophyListStatusColumnTitle: 'Status',
    deglawyTrophyListEditColumnTitle: 'Edit',
    deglawyTrophyListAddButton: 'Add',
    deglawyTrophyListNoImageMessage: 'There are no deglawy Trophy yet. Please add one now',
    // start deglawy trophy form
    editDeglawyTrophyPageTitle: 'Edit Deglawy Trophy',
    addDeglawyTrophyPageTitle: 'Add Deglawy Trophy',
    deglawyTrophyPageFormInfo: 'Deglawy Trophy Info',
    deglawyTrophyPageFormTitle: 'Title',
    deglawyTrophyPageFormArabicTitle: 'Arabic Title',
    deglawyTrophyPageFormPoints: 'Points',
    deglawyTrophyPageFormActiveImage: 'Active Image',
    deglawyTrophyPageFormDimmedImage: 'Dimmed Image',
    deglawyTrophyPageFormErrorCode: 'Dimmed Image',
    deglawyTrophyErrorMessageTrophyWithSamePoints: 'Sorry there is already a trophy with the same points',
    deglawyTrophyUpdatedMessage: 'Updated trophy successfully',
    deglawyTrophyCreatedMessage: 'Created trophy successfully',
    // end deglawy trophy form
    // end deglawy trophies tab

    // start deglawyContent tab
    deglawyContentsTitlesColumnTitle: 'Titles',
    deglawyContentsEditColumnTitle: 'Edit',
    editDeglawyContentPageTitle: 'Edit Deglawy Content',
    addDeglawyContentPageTitle: 'Add Deglawy Content',
    addDeglawyContentPageFormTitle: 'Deglawy Content Info',
    addDeglawyPortalContentPageFormTitle: 'Deglawy Portal Content Info',
    addDeglawyContentPageFormKey: 'Content Title',
    addDeglawyContentPageFormBody: 'Content Body',
    addDeglawyContentPageFormImage: 'Header Image',
    deglawyPortalTab: 'Portal Content Management',
    // end deglawyContent tab

    // start facility tab
    ratingFacilityReportFacilityName: "Facility Name",
    ratingFacilityReportCategoryName: "Category Name",
    ratingFacilityReportBranchName: "Branch Name",
    ratingFacilityReportAreaName: "Area Name",
    ratingFacilityReportRating: "Rating",
    facilityResponseNameColumn: 'Name',
    facilityResponseMembershipColumn: 'Membership',
    facilityResponseRatingColumn: 'Rating',
    facilityResponseDetailsColumn: 'Details',

    //gates
    gatesListPageTitle: "Gates Management",
    gatesListFacilityColumnTitle: "Title",
    gatesListBranchColumnTitle: "Branch",
    gatesListNoGatesMessage: "No Gates",
    gatesListEditColumnTitle: "Edit",
    editGatePageTitle: "Edit Gate",
    addGatePageTitle: "New Gate",
    addGatePageFormTitle: "Add New Gate",
    GatePageFormAvailableBranches: "Branch",

    facilityManagementTab: 'Branch Facilities',
    facilitiesListPageTitle: 'Facilities Management',
    facilitiesListFacilityColumnTitle: 'Facility',
    facilitiesListStatusColumnTitle: 'Status',
    facilitiesListEditColumnTitle: 'Edit',
    FacilityPageFormFacilityAreas: 'Facility Areas',
    FacilityPageFormFacilityForms: 'Facility Forms',
    facilitiesListNoFacilitiesMessage: 'There are No Facilities yet. Please add one now',
    FacilityPageFormTitle: 'Facility Info',
    editFacilityPageTitle: 'Edit Facility',
    addFacilityPageTitle: 'Add Facility',
    FacilityPageFormTitleLabel: 'Title',
    FacilityPageFormArabicTitleLabel: 'Arabic Title',
    FacilityPageFormAvailableBranches: 'Facility Available Branches',
    FacilityPageFormFacilityCategories: 'Facility Categories',
    FacilityPageFormActiveLabel: 'Active',
    FacilityPageFormNotActiveLabel: 'Not Active',
    FacilityPageFormStatus: 'Status',
    facilitiesListEditButton: 'Edit',
    // end facility tab
    // start settings Tab
    settingsListNoSettingsMessage: 'There are no configurations yet.',
    settingsListPageTitle: 'Settings Management',
    settingsListKeyColumnTitle: 'Key',
    settingsListValueColumnTitle: 'Value',
    settingsListEditColumnTitle: 'Edit',
    editSettingsPageTitle: 'Edit Setting',
    addSettingPageFormTitle: 'Setting Info',

    // start statistics Tab
    createWallet: 'Create Wallet',
    DetailedStatisticsTabTitle: 'Detailed Statistics',
    UsersTableTabTitle: 'Users',
    NotRegisteredUsersTabTitle: 'Not Registered Users',
    SuspendUsers: 'Suspended Users',
    statisticsListNameColumnTitle: 'Name',
    statisticsListMemberShipColumnTitle: 'Membership ID',
    statisticsListPhoneNumberColumnTitle: 'Phone Number',
    statisticsListIsMainMemberColumnTitle: 'Main Member',
    preRegisteredListVerificationCodeColumnTitle: 'Code',
    preRegisteredListMemberShipColumnTitle: 'Membership ID',
    preRegisteredListPhoneNumberColumnTitle: 'Phone Number',
    PreRegisteredListNoUsersMessage: 'There are no users Yet.',

    // Featured Offer Tab
    FeaturedOfferManagementTab: 'Featured Offer Management',
    FeaturedOfferPageTitle: 'Featured Offer Management',
    FeaturedOfferListImageColumnTitle: 'Offer',
    FeaturedOfferListTitleColumnTitle: 'Title',
    FeaturedOfferListHotDealColumnTitle: 'Hot Deal',
    FeaturedOfferListOrderColumnTitle: 'Order',
    FeaturedOfferListEditColumnTitle: 'Edit',
    FeaturedOfferListAddButton: 'Add',
    FeaturedOfferListNoImageMessage: 'There are no featured offer yet. Please add one',
    FeaturedOfferAddForm: 'Available Offers',
    FeaturedOfferEditPageTitle: 'Edit Offer',
    FeaturedOfferAddPageTitle: 'New Offer',
    FeaturedOfferFormTitle: 'Offer Info',
    // Featured Offer Tab

    // statistics Tab
    PORTAL_USERS: 'Portal Users',
    MOBILE_USERS: 'Mobile Users',
    SPORTS_USERS: 'Sports Users',
    UNKNOWN_USERS: 'Unknown Users',
    STATISTICS_USERS: 'Users Statistics',
    TOTAL_USERS: 'Total Users:',
    USERS_FROM_PORTAL: 'Users From Portal:',
    USERS_FROM_MOBILE: 'Users From Mobile:',
    USERS_FROM_SPORTS: 'Users From Sports Reservations:',
    USERS_FROM_UNKNOWN: 'Users From Unknown Sources:',
    addCalenderSepratorPageFormTitle: 'Add Calender Seprator',
    addCalenderSepratorPageTitle: 'Add Calender Seprator',
    editCalenderSepratorPageTitle: 'Edit Calender Seprator',
    addCalenderSepratorPageFormName: 'Calender Seprator Title',
    addCalenderSepratorPageFormGallery: 'Calender Seprator Image',
    addCalenderSepratorPageFormDate: 'Calender Seprator Date',
    editEventCategoryPageTitle: 'Edit Event Category',
    addEventCategoryPageTitle: 'Add Event Category',
    addEventCategoryPageFormTitle: 'Add Event Category',
    addEventCategoryPageFormName: 'event category title',
    addEventPageFormName: 'Event Title',
    addEventPageFormGallery: 'Event Image',
    addEventPageFormStartDate: 'Event Start Date',
    addEventPageFormEndDate: 'Event End Date',
    editEventPageTitle: 'Edit Event',
    addEventPageTitle: 'Add Event',
    addEventPageFormDescription: 'Event Description',
    addEventPageFormCategory: 'Event Category',
    addEventPageFormAllDay: 'All Day',
    addEventPageFormStatus: 'Status',
    addEventPageFormStatusActiveLabel: 'Active',
    addEventPageFormStatusInactiveLabel: 'Not active',
    offersListNoMessage: 'There are no offers yet. Please add one now',
    offersListPageTitle: 'Offers Management',
    offersListTitleColumnTitle: 'Title',
    offersListEditColumnTitle: 'Edit',
    steps: 'Steps',
    terms: 'Terms and Conditions',
    offerFormTitle: 'Offer',
    editOfferPageTitle: 'Edit Offer',
    addOfferPageTitle: 'New Offer',
    HotDeal: 'Hot Deal',
    DiscountPercentage: 'dicount percentage',
    NotHotDeal: 'Not Hot Deal',
    totalRgistred: 'Total registered users',
    totalMobileUsers: 'Total mobile users',
    totalWebUsers: 'Total web portal users',
    totalSportsUsers: 'Total sports reservation users',
    totalUnknownUsers: 'Total unknown sources users',
    wifiPackagesPageTitle: 'Wifi Packages',
    editWifiPackagePageTitle: 'Edit Wifi Package',
    addWifiPackagePageTitle: 'Add Wifi Package',
    TRANSACTIONS_RE_NOTIFY_DIALOG_TITLE: 'Renotify sap transaction',
    TRANSACTIONS_RE_NOTIFY_DIALOG_CONTENT: 'Are you sure you want to renotify successful transaction ?',
    sapTransactionsLogs: 'Sap transactions logs',
    sapLogsErrorBlocked: 'blocked or deleted',
    sapLogsErrorPaidBefore: 'already paid',
    sapLogsErrorNoOpenItems: 'there is no open items',
    sapLogsErrorPaid: 'paid',
    sapLogsErrorSomethingwrong: 'something error',
    surveyPageTitle: 'Survey',
    editSurveyPageTitle: 'Edit Survey',
    addSurveyPageTitle: 'Add Survey',
    downloadButton: 'Download Report',
    limitedUsersTab: 'محدودي الصلاحيات',
    accessLevel: 'مستوى الصلاحيات',
    limited: 'محدود',
    full: 'كامل',
    syncUserStatus: 'زامن',
    verified: "تم التحقق",
    membershipId: "رقم العضوية . مثال 2002_1",
    selected: "تم التحديد",
    addAccumulation: 'اضف نقاط للمستخدم',
    updatePhone: "تعديل رقم الهاتف",
    updatePhoneLabel: "يجب ان يكون رقم الهاتف يبدا بكود الدولة مثل . +2",
    points: "النقاط",
    physical: "جوائز مادية",
    bulkSeed: "اضف مجموعه",
    savedMessage: 'تم الحفظ بنجاح',
    details: "details",
    renewalsDetails: "Renewals Details",
    wifiPayment: "wifi Packages payment",
    fawryLogs: "Fawry logs",
    orangeLogs: "Orange logs",
    transactions: "transactions",
    wifiSubscriptions: "Wifi packages subscriptions",
    noSearchWord: "Please enter correct search word",
    deglawyPoints: 'نقط دجلاوي',
    selectWidget: "Please select a widget to start editing.",
    unknownStatus: 'الحالة مجهولة',
    missingFields: 'مدخلات غير كاملة',
    notificationsIsBatchesColumnTitle: 'Is Batches?',
    // Facebook
    fbTableTitle: 'بيانات الفيسبوك للمستخدمين',
    fbEmptyTableMessage: 'لا يوجد حسابات فيسبوك متصلة',
    fbDownloadSheet: 'تحميل كملف إكسل',
    errorDownloadingFile: 'حدث خطأ في تحميل الملف. حاول لاحقا',

    WIFI_PACKAGE: 'باقة واي فاي',
    // Release notes
    releaseNotesTableTitle: 'ملاحظات الاصدارات الجديدة',
    releaseNotesEmptyTableMessage: 'لا يوجد ملاحظات محفوظة',
    notificationsListActiveInActiveColumnTitle: "Cancel schedule",

    deliveryRegionsTableTitle: 'مناطق التوصيل',
    deliveryRegionsEmptyTableMessage: 'لا يوجد مناطق توصيل محفوظة',
    cardsDeliveryTableTitle: 'طلبات استلام البطاقات',
    viewAddressButton: 'تفاصيل العنوان',
    NEW: 'جديد',
    NoAction: "Nothing Happening",
    OtpSent: "Your Code is on the Way!",
    CalimedPoints: "Points Successfully Claimed!",
    LeadsEmptyTableMessage: "No leads were found matching your criteria."
  },
};

export const translate = memoize(
    (key: any, config?: any) => i18n.t(key, config),
    (key: any, config?: any) => (config ? key + JSON.stringify(config) : key),
);

export const setI18nConfig = () => {
  // fallback if no available language fits
  const fallback = {
    languageTag: languageCodes.english, isRTL: false,
  };

  const {
    languageTag, isRTL,
  } = fallback;

  // set i18n-js config
  i18n.translations = {
    [languageTag]: tranlsationGetters.en,
  };
  i18n.locale = languageTag;
  // console.log(i18n.locale);
  // console.log(i18n.translations);
  // console.log(translationGetters[languageTag]());
  // console.log(i18n.locale);
  // console.log(i18n);
};
